import { createTheme } from "@mui/material/styles";
import ThemeOptions, { ThemePaletteOverridesByMode } from "./themeOptions";
import { IUserSettings } from "../types/userSettings";

export const createAppTheme = (
  mode: "light" | "dark",
  userSettings?: IUserSettings | null
) => {
  const overrides: ThemePaletteOverridesByMode | undefined =
    userSettings?.colorOverrides;
  return createTheme(ThemeOptions(mode, overrides));
};

export const theme = createAppTheme("light");

export const GRADIENT_START = "#FFD25F";
export const GRADIENT_END = "#FF5C01";
